import createParse from './create-parse';
import createStringify from './create-stringify';
const defaultReviver = (key, value, { source }) => {
    return BigInt(source);
};
const defaultReplacer = (key, value) => value;
const createJSON = (options) => {
    return {
        parse: createParse(options.unsafeIntegersReviver ?? defaultReviver),
        stringify: createStringify(options.rawJSONReplacer ?? defaultReplacer),
    };
};
export default createJSON;
//# sourceMappingURL=create-json.js.map